import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Events from './Events'
import Locations from './Locations'

import { Route, Switch, Redirect, withRouter } from 'react-router-dom'
import Login from './Login.js'
import BuildingControls from './BuildingControls'
import BuildingDetails from './BuildingDetails'
import Home from './Home'
import { checkInvitation, resetPasswordToken } from '../actions/auth.js'

class Auth extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  static defaultProps = {
    resetPasswordIdentifier: null
  }

  componentDidMount() {}

  render() {
    const isAuthenticated = this.props.account != null

    if (isAuthenticated) {
      return (
        <div className='content'>
          <Switch>
            <Route exact path='/' render={() => <Redirect to='/Home' />} />
            <Route path='/Home' component={Home} />
            <Route path='/Events/:type?' component={Events} />
            <Route path='/Locations/:type?' component={Locations} />
            <Route path='/BuildingControls/:type?' component={BuildingControls} />
            <Route path='/BuildingDetails/:type?' component={BuildingDetails} />
            <Redirect to='/Home' />
          </Switch>
        </div>
      )
    } else {
      let paramsString = this.props.location.search
      let params = new URLSearchParams(paramsString)
      let invitation = params.get('invitation')
      let resetPasswordIdentifier = params.get('resetPassword')
      if (resetPasswordIdentifier) {
        this.props.dispatch(resetPasswordToken(resetPasswordIdentifier))
      }
      let code = params.get('code')
      const { dispatch } = this.props
      dispatch(checkInvitation(invitation))
      return (
        <div className='content'>
          <Switch>
            <Route path='/Login' component={Login} />
            <Redirect to={`/Login${code ? `?linkedInCode=${code}` : ''}`} />
          </Switch>
        </div>
      )
    }
  }
}

const mapStateToProps = state => {
  return {
    account: state.authReducer.account
  }
}

export default withRouter(connect(mapStateToProps)(Auth))



// WEBPACK FOOTER //
// ./src/components/Auth.js